import { render, staticRenderFns } from "./AppSimpleDistrictSelector.vue?vue&type=template&id=0915ef78&scoped=true&"
import script from "./AppSimpleDistrictSelector.vue?vue&type=script&lang=ts&"
export * from "./AppSimpleDistrictSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppSimpleDistrictSelector.vue?vue&type=style&index=0&id=0915ef78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0915ef78",
  null
  
)

export default component.exports